import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 'fit-content',
      minWidth: 106,
      minHeight: 40,
      overflow: 'hidden',
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(1, 1.5),
      backgroundColor: COLORS.neutral.white,
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadiusMedium,

      ...theme.typography.regular14,
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.gray.black,
      whiteSpace: 'nowrap',

      transition: theme.transitions.create(['border-color'], {
        duration: theme.transitions.duration.shortest,
      }),

      '&:hover': {
        borderColor: COLORS.gray.gray50,
      },
      '&$open': {
        borderColor: COLORS.primary.default,
      },

      '&[disabled]': {
        color: COLORS.gray.gray50,
        backgroundColor: COLORS.gray.gray80,

        '& $chevronIcon': {
          color: COLORS.gray.gray50,
        },
      },
    },
    open: {},
    children: {
      minWidth: 0,
      flex: 1,
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
    },
    chevronIcon: {
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.gray.black,
    },
  }),
  { name: 'ButtonDropdown' }
);
